/* eslint-disable */
// @ts-nocheck
import { createContext } from "react";
import type { AppSearchItemData, ItemData } from "types/layout";

export default createContext<{
  sideMenuData: ItemData[];
  appSearchItems?: AppSearchItemData[];
  currentActiveItem: string;
  currentActiveMenu: string;
  isMobileRequest: boolean;
  currentUser: {
    label: string;
    href: string;
  };
  organizationName: string;
  comments: any;
  tasks: any;
  isOnBoard: boolean;
  isPos: boolean;
  showReferral?: boolean;
  tenantID: number;
  aiToolsEnabled?: boolean;
}>(null);
/* eslint-enable */
